export default organisation => ({
  name: organisation.name,
  coc_number: organisation.coc_number,
  account_manager: organisation.account_manager,
  payment_settings: organisation.payment_settings,
  registrations: organisation.registrations.map(registration => ({
    country_code: registration.country_code,
    number: registration.number,
  })),
  billing: {
    primary: organisation.billing.primary ? organisation.billing.primary.id : null,
    secondary: (organisation.billing.secondary || []).map(address => address.id),
  },
  shipping: {
    primary: organisation.shipping.primary ? organisation.shipping.primary.id : null,
    secondary: (organisation.shipping.secondary || []).map(address => address.id),
  },
  phone_numbers: {
    primary: organisation.phone_numbers.primary ? organisation.phone_numbers.primary.id : null,
    secondary: (organisation.phone_numbers.secondary || []).map(phoneNumber => phoneNumber.id),
  },
  metadata: organisation.metadata,
  file_id: organisation.file_id,
});
